// src/features/records/components/RecordDetail/components/ModalHeader.js
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { X } from 'lucide-react';
import RecordDropdownMenu from '../../shared/RecordDropdownMenu';
import styles from '../RecordDetail.module.css';

const ModalHeader = ({ 
  record, 
  onClose, 
  onEdit, 
  onDelete,
  onShare,
  canEdit 
}) => {
  const { t } = useTranslation();
  const [showDropdown, setShowDropdown] = React.useState(false);

  const handleEdit = () => {
    if (onEdit) {
      onEdit(record);
    }
  };

  const handleDelete = () => {
    if (onDelete) {
      onDelete(record);
    }
  };

  const handleShare = () => {
    if (onShare) {
      onShare(record);
    }
  };

  return (
    <div className={styles.modalHeader}>
      {/* Close Button */}
      <button 
        className={styles.iconButton}
        onClick={onClose}
        aria-label={t('common.close', 'Close')}
      >
        <X size={24} />
      </button>

      {/* Header Actions */}
      <div className={styles.headerActions}>
        {canEdit && (
          <RecordDropdownMenu
            isOpen={showDropdown}
            onToggle={setShowDropdown}
            onEdit={handleEdit}
            onDelete={handleDelete}
            onShare={handleShare}
            record={record}
          />
        )}
      </div>
    </div>
  );
};

ModalHeader.propTypes = {
  record: PropTypes.shape({
    id: PropTypes.string.isRequired
  }).isRequired,
  onClose: PropTypes.func.isRequired,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
  onShare: PropTypes.func,
  canEdit: PropTypes.bool
};

export default ModalHeader;
